import React, { useRef, useState, useEffect } from "react";
import Lottie from "react-lottie-player";
import { Card, Box, Typography, useMediaQuery, useTheme } from "@mui/material";

const HoverIcon = ({ animationData, title, description, size = 96 }) => {
  const playerRef = useRef();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    if (isMobile) {
      playerRef.current?.play();
    } else {
      playerRef.current?.stop();
    }
  }, [isMobile]);

  return (
    <Card
      onMouseEnter={() => {
        if (!isMobile) {
          setHovered(true);
          playerRef.current?.play();
        }
      }}
      onMouseLeave={() => {
        if (!isMobile) {
          setHovered(false);
          playerRef.current?.stop();
        }
      }}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        p: 4,
        borderRadius: "1.5rem",
        background: hovered
          ? "linear-gradient(145deg, rgba(232, 245, 255, 1), rgba(255,255,255,1))"
          : "linear-gradient(145deg, rgba(255,255,255,1), rgba(245, 250, 255, 1))",
        border: `1px solid ${
          hovered ? "var(--primary-blue)" : "rgba(0,0,0,0.08)"
        }`,
        boxShadow: hovered
          ? "0 12px 36px rgba(0, 0, 0, 0.12)"
          : "0 8px 30px rgba(0, 0, 0, 0.05)",
        transition: "all 0.3s ease",
        transform:
          hovered && !isMobile ? "translateY(-6px) scale(1.04)" : "none",
        cursor: isMobile ? "default" : "pointer",
        textAlign: "center",
      }}
      elevation={0}
    >
      <Lottie
        ref={playerRef}
        animationData={animationData}
        play={isMobile} // always play on mobile
        loop
        style={{ width: size, height: size }}
      />

      <Typography
        variant="h5"
        fontWeight={700}
        sx={{
          color: "var(--secondary-blue)",
          mt: 1,
        }}
      >
        {title}
      </Typography>

      <Typography
        variant="subtitle1"
        sx={{
          color: "text.secondary",
          fontSize: "1rem",
          lineHeight: 1.5,
          maxWidth: 260,
        }}
      >
        {description}
      </Typography>
    </Card>
  );
};

export default HoverIcon;
